import React from 'react';
import './back-to-catalogue.scss';
import { useNavigation } from 'react-navi';
import BackToBanner from 'components/back-to-banner';
import { BackToCatalogueProps } from './back-to-catalogue-props';
import { getBackToCataloguesQuerystring } from '../create-catalogue-form';

/**
 * Navigates to the catalogue listing page.
 *
 * Note this maintains any existing querystring values.
 *
 * Important: This Material-UI `Link` uses the base `a` component instead of the
 * react-navi `Link` to allow window.onbeforeunload functionality as the
 * react-navi `Link` will not unload the window on route change.
 */
export const BackToCatalogue: React.FC<BackToCatalogueProps> = () => {
  const navigation = useNavigation();
  const { query } = navigation.getCurrentValue().url;
  const href = getBackToCataloguesQuerystring(query);

  return (
    <BackToBanner
      href={href}
      linkProps={{ component: 'a' }}
    >
      Back to your catalogue listings
    </BackToBanner>
  );
};
